export default window.React;



// WEBPACK FOOTER //
// ./src/commons/services/React.js